import React, { useState } from "react"
import Lightbox from "yet-another-react-lightbox"
import "yet-another-react-lightbox/styles.css"
import { WorkshopGallerySmallType } from "../../types/mainModulTypes"
import { API } from "../../constants/constants"
import { Swiper, SwiperSlide } from "swiper/react"
import { Pagination } from "swiper/modules"
import "swiper/css"
import "swiper/css/pagination"

export default function WorkshopGallerySmall(props: WorkshopGallerySmallType) {
    const [index, setIndex] = useState(-1)

    // Array mit allen Bildern der Galerie in der Reihenfolge
    const slides = [
        {
            src: API + props?.workshopGallerySmallLine1Image1?.url,
            alt: props.workshopGallerySmallLine1Image1?.description ?? props.workshopGallerySmallLine1Image1?.name,
        },
        {
            src: API + props?.workshopGallerySmallLine1Image2?.url,
            alt: props.workshopGallerySmallLine1Image2?.description ?? props.workshopGallerySmallLine1Image2?.name,
        },
        {
            src: API + props?.workshopGallerySmallLine2Image1?.url,
            alt: props.workshopGallerySmallLine2Image1?.description ?? props.workshopGallerySmallLine2Image1?.name,
        },
        {
            src: API + props?.workshopGallerySmallLine2Image2?.url,
            alt: props.workshopGallerySmallLine2Image2?.description ?? props.workshopGallerySmallLine2Image2?.name,
        },
        {
            src: API + props?.workshopGallerySmallLine2Image3?.url,
            alt: props.workshopGallerySmallLine2Image3?.description ?? props.workshopGallerySmallLine2Image3?.name,
        },
    ]

    return (
        <>
            <div className="px-4">
                <Swiper modules={[Pagination]} slidesPerView={1} pagination spaceBetween={10} className="mySwiper sm:!hidden ">
                    {slides.map((slide, index) => (
                        <SwiperSlide key={index}>
                            <img src={slide.src} alt={slide.alt} className="aspect-[4/3] w-full object-cover rounded-default" />
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
            <div className="max-w-content-sm mx-auto  grid-cols-3 gap-8 px-4 hidden sm:grid">
                <img
                    src={API + props?.workshopGallerySmallLine1Image1?.url}
                    alt={props.workshopGallerySmallLine1Image1?.description ?? props.workshopGallerySmallLine1Image1?.name}
                    className="h-[22rem] w-full col-span-1 row-span-2 object-cover rounded-default cursor-pointer"
                    onClick={() => setIndex(0)}
                />
                <img
                    src={API + props?.workshopGallerySmallLine1Image2?.url}
                    alt={props.workshopGallerySmallLine1Image2?.description ?? props.workshopGallerySmallLine1Image2?.name}
                    className="col-span-2 row-span-2 h-[22rem] w-full object-cover rounded-default cursor-pointer"
                    onClick={() => setIndex(1)}
                />
                <img
                    src={API + props?.workshopGallerySmallLine2Image1?.url}
                    alt={props.workshopGallerySmallLine2Image1?.description ?? props.workshopGallerySmallLine2Image1?.name}
                    className="col-span-1 row-span-1 h-44 w-full object-cover rounded-default cursor-pointer"
                    onClick={() => setIndex(2)}
                />
                <img
                    src={API + props?.workshopGallerySmallLine2Image2?.url}
                    alt={props.workshopGallerySmallLine2Image2?.description ?? props.workshopGallerySmallLine2Image2?.name}
                    className="col-span-1 row-span-1 h-44 w-full object-cover rounded-default cursor-pointer"
                    onClick={() => setIndex(3)}
                />
                <img
                    src={API + props?.workshopGallerySmallLine2Image3?.url}
                    alt={props.workshopGallerySmallLine2Image3?.description ?? props.workshopGallerySmallLine2Image3?.name}
                    className="col-span-1 row-span-1 h-44 w-full object-cover rounded-default cursor-pointer"
                    onClick={() => setIndex(4)}
                />
            </div>

            <Lightbox slides={slides} open={index >= 0} index={index} close={() => setIndex(-1)} />
        </>
    )
}
